import PropTypes from "prop-types";
import { connect } from "react-redux";
import values from "lodash/values";
import {
	resetAllProductsFilter,
	setProductsFilter,
	setProductsFilters,
	unsetProductsFilter,
} from "app/pages/Listing/ProductFilters/productsFilterActionCreators";

import {
	getBadgeFilterValues,
	getDestinationFilterValues,
	getMonthFilterValues,
	getSelectedFacets,
	getTopDestinationFilterValues,
	getTopicFilterValues,
	getVisibleFilters,
	getVisibleProducts,
	getZoneFilterValues,
	shouldDisplayDestinationFilter,
} from "app/pages/Listing/productsSelector";
import { bindActionCreators } from "redux";
import without from "lodash/without";
import groupBy from "lodash/groupBy";
import {
	hideAsideProductFilters,
	toggleAsideProductFilters,
} from "app/pages/.shared/AsidePanel/AsideProductFilters/AsideProductFiltersActionCreators";
import syncFiltersWithUrl from "app/pages/Listing/ProductFilters/syncFiltersWithUrl";
import { TOP_TOPIC_FILTER_VALUES } from "app/constants";

const CategorizedProductsFilter = props => {
	const { productsFilters = {}, setProductsFilters, renderComponent } = props;
	syncFiltersWithUrl(productsFilters, setProductsFilters);
	return renderComponent(props);
};

CategorizedProductsFilter.propTypes = {
	renderComponent: PropTypes.func,
};

const mapStateToProps = state => {
	const topDestinationsFilterValues = getTopDestinationFilterValues(state);
	const products = getVisibleProducts(state);

	const topTopicFilterValues = TOP_TOPIC_FILTER_VALUES; // TODO actuellement en dure en attendant de le recuperer depuis une source
	const topicToHide = ["Luxe"]; // TODO On retire les topics Luxe car ils ont été taggué par la prod il y a longtemps et on ne veut pas que ce soit dupliquer avec les filtres badges
	const productsList = state.products;

	return {
		isSticky: state.menu.isListingFilterSticky,
		productsCount: products.length,
		productsFilters: state.productsFilters,
		productsActiveFilters: values(state.productsFilters),
		visibleFilters: getVisibleFilters(state),
		selectedFacets: getSelectedFacets(state),
		zoneFilterValues: getZoneFilterValues(state),
		destinationFilterValues: getDestinationFilterValues(state),
		topDestinationsFilterValues: topDestinationsFilterValues,
		topTopicFilterValues: topTopicFilterValues,
		topicFilterValues: without(
			getTopicFilterValues(state),
			...topTopicFilterValues,
			...topicToHide
		),
		monthsFilterValues: groupBy(getMonthFilterValues(state), monthTimestamp => {
			const date = new Date(Number(monthTimestamp));
			return date.getUTCFullYear();
		}),
		badgesFilterValues: getBadgeFilterValues(state),
		displayFilters: productsList.length !== 0,
		displayDestinationFilter: shouldDisplayDestinationFilter(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			setProductsFilter,
			unsetProductsFilter,
			toggleAsideProductFilters,
			hideAsideProductFilters,
			resetAllProductsFilter,
			setProductsFilters,
		},
		dispatch
	);
};

export const CategorizedProductsFilterContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(CategorizedProductsFilter);
